import { Context } from '@/classes/models'

import routeParameter from './routeParameter'

export default {
  mixins: [routeParameter],

  computed: {
    /*
     * Create an instance of the context class
     */
    context () {
      let { partner, business, merchant, configuration = { id: null } } = this.$store.state.context.context || {}

      if (this.hasRouteParameter('configurationId')) {
        // If the url contains a configuration id and is different than the one selected, use that instead of the one selected in the context
        configuration = configuration.id !== this.getRouteParameter('configurationId') ? { id: this.getRouteParameter('configurationId', true) } : configuration
      }

      return new Context({ partner, business, merchant, configuration })
    }
  },

  methods: {
    /*
     * Create a on-the-fly instance of the context class to overwrite some values
     */
    createContext (context) {
      return new Context({ ...this.context, ...context })
    },

    createSegmentedContext (segments = ['business', 'merchant', 'configuration']) {
      return new Context({ ...segments.reduce((result, segment) => this.context.isSelected(segment) ? Object.assign({}, result, { [segment]: this.context[segment] }) : result, {}) })
    }
  }
}
